module.exports = __webpack_public_path__ + "img/icon-512x512.0314e996.jpg";